import { render, staticRenderFns } from "./accordion-body.vue?vue&type=template&id=d518059c&"
import script from "./accordion-body.vue?vue&type=script&lang=js&"
export * from "./accordion-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports